import menuSaga from "./menu/menu.saga";
import activitiesSaga from "./activities/activities.saga";
import calendarSaga from "./calendar/calendar.saga";
import mainSaga from "./main/main.saga";
import quickSaga from "./quick/quick.saga";

const exportSaga = { menuSaga, activitiesSaga, calendarSaga, mainSaga, quickSaga };

export default exportSaga;